import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Meta } from '@df/core/meta/meta';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { BehaviorSubject } from 'rxjs';
import { OffCanvasMenuBodyComponent } from './off-canvas-menu-body.component';
@Component({
    selector: 'off-canvas-menu',
    templateUrl: './off-canvas-menu.component.html',
    styleUrls: ['./off-canvas-menu.component.scss'],
    standalone: true,
    imports: [OffClickModule, OffCanvasMenuBodyComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OffCanvasMenuComponent {
    @Input()
    offCanvasState!: BehaviorSubject<boolean>;

    constructor(private meta: Meta) {
        this.meta.routerEvents.pipe(takeUntilDestroyed()).subscribe(() => this.close());
    }

    close() {
        this.offCanvasState.next(false);
    }
}
